import { useQuery, useMutation } from '@apollo/client';
import { useParams } from 'react-router';

import {
  CompanyTfsSpaceQuery,
  CompanyTfsSpaceQueryVariables,
  ProvisionTfsSpaceMutation,
  ProvisionTfsSpaceMutationVariables,
  TfsRegion,
} from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { CompanyFileStorageView, CompanyFileStorageViewProps } from '../components/company_file_storage';
import { companyTFSSpaceQuery, provisionTFSSpaceMutation } from '../graphql';

class LoadingContainer extends Loader<
  CompanyTfsSpaceQuery,
  CompanyFileStorageViewProps,
  CompanyTfsSpaceQueryVariables
> {}

export const CompanyFileStorageContainer = () => {
  const { company_id: companyId } = useParams() as { company_id: string };
  const result = useQuery<CompanyTfsSpaceQuery, CompanyTfsSpaceQueryVariables>(companyTFSSpaceQuery, {
    variables: {
      company_id: companyId,
    },
  });
  const [provisionSpaceMutate] = useMutation<ProvisionTfsSpaceMutation, ProvisionTfsSpaceMutationVariables>(
    provisionTFSSpaceMutation,
  );

  return (
    <LoadingContainer
      result={result}
      mapData={({ data }) => ({
        data: { company: data.company ?? null, __typename: 'Query' },
        provisionSpace: async (spaceName: string, region: TfsRegion) => {
          await provisionSpaceMutate({
            refetchQueries: [
              {
                query: companyTFSSpaceQuery,
                variables: { company_id: companyId },
              },
            ],
            variables: {
              input: {
                companyId,
                spaceName,
                region,
              },
            },
          });
        },
      })}>
      {({ data, provisionSpace }) => <CompanyFileStorageView data={data} provisionSpace={provisionSpace} />}
    </LoadingContainer>
  );
};
